module.exports = __webpack_public_path__ + "img/card-example.ac039ff7.jpg";